import {formatTitle} from "../colourwayBuilders"
import {ColourwayData} from "../../models/searchApi"
import {SofaType, SummaryType} from "../../config/constants"

interface GetTitleProps {
    type: SummaryType
    enabledSearchDesc: boolean
    title: string
    selectedColourway: ColourwayData | undefined
    fit: string | null | undefined
    department: string
    isEnglishLang: boolean
}

const getTitleUtil = ({
    type,
    enabledSearchDesc,
    title,
    selectedColourway,
    fit,
    department,
    isEnglishLang,
}: GetTitleProps) => {
    return enabledSearchDesc && type !== SofaType
        ? selectedColourway?.t || ""
        : formatTitle({
              title,
              selectedColourway,
              fit,
              department,
              isEnglishLang,
          })
}

export default getTitleUtil
